/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "giftcards": {
            "nested": {
              "GiftCard": {
                "fields": {
                  "serverId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "state": {
                    "type": "squareup.client.giftcards.GiftCard.State",
                    "id": 2,
                    "rule": "optional"
                  },
                  "balanceMoney": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "activity": {
                    "type": "squareup.client.giftcards.Transaction",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "cardType": {
                    "type": "squareup.client.giftcards.GiftCard.CardType",
                    "id": 6,
                    "rule": "optional"
                  },
                  "gan": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "v2Id": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "themeId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "State": {
                    "values": {
                      "UNKNOWN": 0,
                      "PENDING": 1,
                      "ACTIVE": 2,
                      "FROZEN": 3,
                      "INACTIVE": 4
                    }
                  },
                  "CardType": {
                    "values": {
                      "SKIPPED": 0,
                      "PHYSICAL": 1,
                      "ELECTRONIC": 2,
                      "THIRD_PARTY": 3
                    }
                  }
                }
              },
              "Transaction": {
                "fields": {
                  "id": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.client.giftcards.Transaction.Type",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "LOAD": 1,
                      "SPEND": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.giftcards?.nested?.GiftCard && !$root.nested?.squareup?.nested?.client?.nested?.giftcards?.nested?.GiftCard?.nested?.State && !$root.nested?.squareup?.nested?.client?.nested?.giftcards?.nested?.GiftCard?.nested?.CardType && !$root.nested?.squareup?.nested?.client?.nested?.giftcards?.nested?.Transaction && !$root.nested?.squareup?.nested?.client?.nested?.giftcards?.nested?.Transaction?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GiftCard @ squareup/client/gift_cards/data.proto at 15:1
 */
export const GiftCard = $root.lookupType('squareup.client.giftcards.GiftCard');
fixType(GiftCard, {
  serverId: {
    required: true
  },
  state: {
    required: true
  },
  panSuffix: {
    required: true
  },
  cardType: {
    required: true
  }
});
Builder.createAndAttachToType(GiftCard);
/**
 * SOURCE State @ squareup/client/gift_cards/data.proto at 19:3
 */
GiftCard.State = $root.lookupEnum('squareup.client.giftcards.GiftCard.State').values;
/**
 * SOURCE CardType @ squareup/client/gift_cards/data.proto at 48:3
 */
GiftCard.CardType = $root.lookupEnum('squareup.client.giftcards.GiftCard.CardType').values;
/**
 * SOURCE Transaction @ squareup/client/gift_cards/data.proto at 72:1
 */
export const Transaction = $root.lookupType('squareup.client.giftcards.Transaction');
fixType(Transaction, {
  id: {
    required: true
  },
  createdAt: {
    required: true
  },
  description: {
    notEmpty: true
  },
  amount: {
    required: true
  },
  type: {
    required: true
  }
});
Builder.createAndAttachToType(Transaction);
/**
 * Type of transaction i.e. whether it adds or subtracts to the gift card balance.
 *
 * SOURCE Type @ squareup/client/gift_cards/data.proto at 74:3
 */
Transaction.Type = $root.lookupEnum('squareup.client.giftcards.Transaction.Type').values;